export default __webpack_public_path__ + "static/media/angle-right-solid.0b4b61bc.svg";